// Resolves once the browser has drawn the frame after this call, so the frame
// a tap waits for (what Chrome reports as INP) is on screen before heavy work
// starts. The timeout covers a hidden tab or a headset session, where the
// page draws no frames.
export function afterNextPaint() {
  return new Promise((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };
    requestAnimationFrame(() => setTimeout(finish, 0));
    setTimeout(finish, 500);
  });
}
